import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OptInPreloadStrategy } from 'polly-commons';
import { PollyManageApplicationDesktopPageComponent } from './modules/polly-manage/modules/app-launch-module/components';

const routes: Routes = [
  { path: '', redirectTo: 'manage', pathMatch: 'full' },
  {
    path: 'runs/:sessionId/:appUrl/app',
    component: PollyManageApplicationDesktopPageComponent,
  },
  {
    path: 'manage',
    loadChildren: () => import('./modules/polly-manage/polly-manage.module').then((m) => m.PollyManageModule),
  },
  { path: 'data-lake', redirectTo: 'manage/discover' },
  { path: 'data-lake/dashboard', redirectTo: 'manage/discover' },
  { path: 'user-project', redirectTo: 'manage/workspaces' },
  { path: 'main', redirectTo: 'manage/applications' },
  { path: '**', redirectTo: 'manage' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: OptInPreloadStrategy })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
